<script>
  import { token } from "./store/token.js";

  import { fetch_user_list } from "./api/request";
  import Sidebar from "./Sidebar.svelte";
  let sidebar_show = false;

  let prefix = "";
  //let select_env = "prod";
  let select_tier = "all";
  let select_activity_condition = "all";
  let select_sort = "created_at_desc";

  let select_index = 0;

  let priority_key_mask = [
    "avatar_url",
    "email",
    "name",
    "artist_name",
    "created_at",
  ];

  let user_list = {
    records: [],
  };

  const wait_for_fetch_user_list = (async () => {
    user_list = await fetch_user_list($token);
  })();

  const fetch_user_activity_log = async (user_id) => {
    const response = await fetch(
      //`https://staging.api.control.vollume.com/admin/user/${user_id}/activity/log`,
      `${process.env.API_ROOT}/admin/user/${user_id}/activity/log`,
      {
        headers: {
          Authorization: "Bearer " + $token,
        },
      }
    );
    return await response.json();
  };

  const fetch_user_songs = async (user_id) => {
    const response = await fetch(
      //`https://staging.api.control.vollume.com/admin/user/${user_id}/song/list`,
      `${process.env.API_ROOT}/admin/user/${user_id}/song/list`,
      {
        headers: {
          Authorization: "Bearer " + $token,
        },
      }
    );
    return await response.json();
  };

  const fetch_user_subscription = async (user_id) => {
    const response = await fetch(
      //`https://staging.api.control.vollume.com/admin/user/${user_id}/subscription`,
      `${process.env.API_ROOT}/admin/user/${user_id}/subscription`,
      {
        headers: {
          Authorization: "Bearer " + $token,
        },
      }
    );
    return await response.json();
  };

  const determine_activity_filter = (user, condition) => {
    if (condition == 'all') {
      return true
    }

    if (condition == 'more_than_one_audio') {
      return user.audio_count > 1
    }

    return true
  }

  const determine_subscription_filter = (user, selected_tier) => {
    if (selected_tier == "all") {
      return true;
    }

    /*if (selected_tier == 'trial_active') {
      return user.trial_active == 1
    }

    if (selected_tier == 'trial_expired') {
      return user.trial_active == 0
    }*/

    if (selected_tier == "basic") {
      return user.plan_id == null;
    }

    if (selected_tier == "paid") {
      return user.plan_id != null;
    }

    if (selected_tier == "pro-50") {
      return user.plan_id == "pro-50-month" || user.plan_id == "pro-50-year";
    }

    if (selected_tier == "pro-200") {
      return user.plan_id == "pro-200-month" || user.plan_id == "pro-200-year";
    }

    if (selected_tier == "pro-2000") {
      return (
        user.plan_id == "pro-2000-month" || user.plan_id == "pro-2000-year"
      );
    }

    if (selected_tier == "workspace-individual-seats") {
      return (
        user.workspace_subscription_plan_id == "workspace-individual-seats-yearly"
      )
    }

    if (selected_tier == "workspace-business-seats") {
      return (
        user.workspace_subscription_plan_id == "workspace-team-seats-yearly"
      )
    }

    if (selected_tier == "workspace-organisation-seats") {
      return (
        user.workspace_subscription_plan_id == "workspace-seats-yearly"
      )
    }

    if (selected_tier == "pro-max") {
      return user.plan_id == "pro-max-month" || user.plan_id == "pro-max-year";
    }

    if (selected_tier == "inactive-30-days") {
      return (
        new Date(user.last_login).getTime() >
        new Date().getTime() - 1000 * 60 * 60 * 24 * 30
      );
    }

    if (selected_tier == "inactive-60-days") {
      return (
        new Date(user.last_login).getTime() >
        new Date().getTime() - 1000 * 60 * 60 * 24 * 60
      );
    }

    if (selected_tier == "inactive-90-days") {
      return (
        new Date(user.last_login).getTime() >
        new Date().getTime() - 1000 * 60 * 60 * 24 * 90
      );
    }
  };

  $: filtered_users = user_list.records
    .filter((user) => {
      if (user.email && user.workspace_id != null) {
        return (
          (prefix
            ? (
              user.email.toLowerCase().indexOf(prefix.toLowerCase()) >= 0
              || (user.name ? user.name.toLowerCase().indexOf(prefix.toLowerCase()) >= 0 : false)
            )
            : true)
          //&& user.envs.indexOf(select_env) >= 0
          && determine_subscription_filter(user, select_tier)
          && determine_activity_filter(user, select_activity_condition)
        );
      } else {
        return false;
      }
    })
    .sort((a, b) => {
      if (select_sort == "created_at_desc") {
        return a.created_at < b.created_at;
      }

      if (select_sort == "created_at_asc") {
        return a.created_at > b.created_at;
      }

      if (select_sort == "last_login_desc") {
        return a.last_login < b.last_login;
      }

      if (select_sort == "last_login_asc") {
        return a.last_login > b.last_login;
      }

      const email_user_a = a.email;
      const email_user_b = b.email;
      return email_user_a.localeCompare(email_user_b, "en", {
        sensitivity: "base",
      });
    });

  $: selected_user = filtered_users ? filtered_users[select_index] : null;

  const export_user_list_as_csv = () => {
    const csv_data = filtered_users
      .map((user) => {
        return [user.email, user.created_at].join(",");
      })
      .join("\n");

    let csv_content = "data:text/csv;charset=utf-8," + csv_data;

    var encoded_uri = encodeURI(csv_content);
    var link = document.createElement("a");
    link.setAttribute("href", encoded_uri);
    link.setAttribute("download", `Control User Export ${new Date()}.csv`);
    document.body.appendChild(link); // Required for FF

    link.click();
  };

  const remove_from_production_environment = async (selected_user) => {
    const response = await fetch(
      //`https://staging.api.control.vollume.com/admin/user/${selected_user.user_id}/login/prod/delete`,
      `${process.env.API_ROOT}/admin/user/${selected_user.user_id}/login/prod/delete`,
      {
        headers: {
          Authorization: "Bearer " + $token,
        },
        method: "post",
      }
    );
    const json = await response.json();

    user_list = await fetch_user_list($token);

    return;
  };
</script>

{#await wait_for_fetch_user_list}
  <div class="ds-loading">
    <div class="ds-spinner"></div>
    <p>Loading user list</p>
  </div>
{:then finished}
  <div class="page-container">
    <div class="ds-page-header">
      <div>
        <h1 class="ds-page-title">User List</h1>
        <p class="ds-page-subtitle">Browse, filter, and edit user records</p>
      </div>
    </div>

    <div class="master-detail-layout">
      <div class="filter-panel ds-card">
        <!--
        <select class="mb-2 form-control" bind:value={select_env}>
          <option value="prod">Production environment</option>
          <option value="staging">Staging environment</option>
          <option value="not logged">Not logged</option>
        </select>
        -->
        <div class="ds-field">
          <label class="ds-label" for="filter-tier">Subscription tier</label>
          <select id="filter-tier" class="ds-select" bind:value={select_tier}>
            <option value="all">All subscription tiers</option>

            <option value="workspace-individual-seats">Workspace Individual</option>
            <option value="workspace-business-seats">Workspace Business</option>
            <option value="workspace-organisation-seats"
              >Workspace Organisation</option
            >

            <option value="basic">Only Basic users</option>
            <!--<option value="trial_active">Only active trial</option>
            <option value="trial_expired">Only expired trial</option>-->
            <option value="paid">Only paying users</option>
            <option value="pro-50">Only Pro 50 users</option>
            <option value="pro-200">Only Pro 200 users</option>
            <option value="pro-2000">Only Pro 2000 users</option>
            <option value="pro-max">Only Pro Max users</option>
            <option value="inactive-30-days"
              >Exclude users inactive for 30+ days</option
            >
            <option value="inactive-60-days"
              >Exclude users inactive for 60+ days</option
            >
            <option value="inactive-90-days"
              >Exclude users inactive for 90+ days</option
            >
          </select>
        </div>

        <div class="ds-field">
          <label class="ds-label" for="filter-activity">Activity</label>
          <select id="filter-activity" class="ds-select" bind:value={select_activity_condition}>
            <option value="all">All users</option>
            <option value="more_than_one_audio">At least some audio upload</option>
          </select>
        </div>

        <div class="ds-field">
          <label class="ds-label" for="filter-sort">Sort by</label>
          <select id="filter-sort" class="ds-select" bind:value={select_sort}>
            <option value="created_at_desc"
              >Sort by user created at descending</option
            >
            <option value="created_at_asc">Sort by user created at ascending</option
            >
            <option value="last_login_desc">Sort by last login descending</option>
            <option value="last_login_asc">Sort by last login ascending</option>
          </select>
        </div>

        <div class="ds-field">
          <label class="ds-label" for="filter-search">Search</label>
          <input id="filter-search" class="ds-search" placeholder="Filter by email or name" bind:value={prefix} />
        </div>

        <div class="list-toolbar">
          <span class="ds-chip ds-chip-accent">{filtered_users.length} users</span>
          <button
            type="button"
            class="ds-btn ds-btn-primary ds-btn-sm"
            on:click={() => {
              export_user_list_as_csv();
            }}
          >
            Export as CSV
          </button>
        </div>

        <select class="user-list-select" bind:value={select_index} size={20}>
          {#each filtered_users as user, i}
            <option value={i}>{user.email} ({user.workspace_title})</option>
          {/each}
        </select>
      </div>

      {#if selected_user}
        <div class="detail-panel ds-card">
          <h2>Workspace</h2>

          <div class="ds-field">
            <label class="ds-label" for="workspace-title">Title</label>
            <input
              id="workspace-title"
              type="text"
              aria-label="Workspace title"
              class="ds-input"
              value={selected_user.workspace_title}
            />
          </div>

          <div class="ds-field">
            <label class="ds-label" for="workspace-id">ID</label>
            <input
              id="workspace-id"
              type="text"
              aria-label="Workspace ID"
              class="ds-input"
              value={selected_user.workspace_id}
            />
          </div>

          <h2>Workspace Subscription</h2>

          {#if selected_user.workspace_subscription_plan_id}
            <div class="ds-field">
              <label class="ds-label" for="workspace-sub-plan-id">Plan ID</label>
              <input
                id="workspace-sub-plan-id"
                type="text"
                aria-label="Workspace subscription plan ID"
                class="ds-input"
                value={selected_user.workspace_subscription_plan_id}
              />
            </div>

            <div class="ds-field">
              <label class="ds-label" for="workspace-sub-id">Subscription ID</label>
              <input
                id="workspace-sub-id"
                type="text"
                aria-label="Workspace subscription ID"
                class="ds-input"
                value={selected_user.workspace_subscription_id}
              />
            </div>

            <div class="ds-field">
              <label class="ds-label" for="workspace-sub-seats">Subscription seats</label>
              <input
                id="workspace-sub-seats"
                type="text"
                aria-label="Workspace subscription seats"
                class="ds-input"
                value={selected_user.workspace_plan_quantity}
              />
            </div>
          {:else}
            <p class="free-plan-note">Free plan</p>
          {/if}

          <h2>User detail</h2>
          <div class="action-row">
            <button class="ds-btn ds-btn-secondary ds-btn-sm" on:click={() => (sidebar_show = !sidebar_show)}
              >Send push notification</button
            >
            <button class="ds-btn ds-btn-secondary ds-btn-sm"
              >Invitations {selected_user.invitation_count} / {parseInt(
                selected_user.invitation_limit,
              ) + parseInt(selected_user.invitation_boost)}</button
            >
            <button
              class="ds-btn ds-btn-danger ds-btn-sm"
              on:click={() => {
                remove_from_production_environment(selected_user);
              }}>Remove from production environment</button
            >
          </div>

          {#each priority_key_mask.concat(Object.keys(selected_user).filter((key) => priority_key_mask.indexOf(key) == -1)) as user_key}
            {#if selected_user[user_key]}
              <div class="ds-field">
                <label class="ds-label" for="field-{user_key}">{user_key}</label>
                {#if selected_user.avatar_url && user_key == "avatar_url"}
                  <a href={selected_user.avatar_url} target="_blank">
                    <img
                      class="avatar"
                      src={selected_user.avatar_url}
                      alt={selected_user.email}
                    />
                  </a>
                {:else if selected_user.avatar_url == null && user_key == "avatar_url"}
                  &nbsp;
                {:else}
                  <input
                    id="field-{user_key}"
                    type="text"
                    aria-label={user_key}
                    class="ds-input"
                    bind:value={selected_user[user_key]}
                  />
                {/if}
              </div>
            {/if}
          {/each}

          <h2>Subscription (legacy)</h2>
          {#await fetch_user_subscription(selected_user.user_id)}
            <div class="ds-loading inline">
              <div class="ds-spinner"></div>
              <p>Loading subscription</p>
            </div>
          {:then subscription}
            <div class="ds-field">
              <label class="ds-label" for="legacy-sub-plan">Plan</label>
              <input
                id="legacy-sub-plan"
                type="text"
                aria-label="Legacy subscription plan"
                class="ds-input"
                value={subscription.plan_title}
              />
            </div>

            <div class="ds-field">
              <label class="ds-label" for="legacy-sub-billing">Billing period</label>
              <input
                id="legacy-sub-billing"
                type="text"
                aria-label="Legacy subscription billing period"
                class="ds-input"
                value={subscription.plan_id.indexOf("month") > -1
                  ? "month"
                  : "year"}
              />
            </div>

            <div class="ds-field">
              <label class="ds-label" for="legacy-sub-status">Status</label>
              <input
                id="legacy-sub-status"
                type="text"
                aria-label="Legacy subscription status"
                class="ds-input"
                value={subscription.status}
              />
            </div>

            <div class="ds-field">
              <label class="ds-label" for="legacy-sub-created">Created at</label>
              <input
                id="legacy-sub-created"
                type="text"
                aria-label="Legacy subscription created at"
                class="ds-input"
                value={subscription.created_at_formatted}
              />
            </div>

            <div class="ds-field">
              <label class="ds-label" for="legacy-sub-expires">Expires at</label>
              <input
                id="legacy-sub-expires"
                type="text"
                aria-label="Legacy subscription expires at"
                class="ds-input"
                value={subscription.expires_at_formatted}
              />
            </div>
          {:catch error}
            <p class="ds-error">Failed to load the subscription.</p>
          {/await}

          <h2>Activity log</h2>
          {#await fetch_user_activity_log(selected_user.user_id)}
            <div class="ds-loading inline">
              <div class="ds-spinner"></div>
              <p>Loading activity log</p>
            </div>
          {:then activity_log}
            <div class="ds-table-wrap">
              <table class="ds-table">
                <thead>
                  <tr>
                    <th>Device</th>
                    <th>Type</th>
                    <th>Platform</th>
                    <th>Location</th>
                    <th>IP</th>
                    <th>Created</th>
                  </tr>
                </thead>
                <tbody>
                  {#each activity_log.records as activity, i}
                    <tr>
                      <td>{activity.device_name}</td>
                      <td>{activity.device_type}</td>
                      <td>{activity.device_platform}</td>
                      <td>{activity.location}</td>
                      <td>{activity.ip}</td>
                      <td>{activity.created_at}</td>
                    </tr>
                  {/each}
                  {#if activity_log.records.length === 0}
                    <tr>
                      <td colspan="6" class="ds-empty">No activity recorded.</td>
                    </tr>
                  {/if}
                </tbody>
              </table>
            </div>
          {:catch error}
            <p class="ds-error">Failed to load the activity log.</p>
          {/await}

          <h2>Uploaded songs</h2>
          {#await fetch_user_songs(selected_user.user_id)}
            <div class="ds-loading inline">
              <div class="ds-spinner"></div>
              <p>Loading songs</p>
            </div>
          {:then song_list}
            <div class="ds-table-wrap">
              <table class="ds-table">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Filename</th>
                    <th>Duration</th>
                    <th>Artist</th>
                    <th>Created</th>
                  </tr>
                </thead>
                <tbody>
                  {#each song_list.records as audio, i}
                    <tr>
                      <td>{audio.title}</td>
                      <td>{audio.original_filename}</td>
                      <td>{audio.duration}</td>
                      <td>{audio.metadata_artist}</td>
                      <td>{audio.created_at}</td>
                    </tr>
                  {/each}
                  {#if song_list.records.length === 0}
                    <tr>
                      <td colspan="5" class="ds-empty">No songs uploaded.</td>
                    </tr>
                  {/if}
                </tbody>
              </table>
            </div>
          {:catch error}
            <p class="ds-error">Failed to load the activity log.</p>
          {/await}
          <Sidebar
            bind:show={sidebar_show}
            bind:user_id={selected_user.user_id}
            bind:email={selected_user.email}
          />
        </div>
      {:else}
        <div class="detail-panel ds-card">
          <div class="ds-empty">Select a user from the list to see details.</div>
        </div>
      {/if}
    </div>
  </div>
{:catch error}
  <p class="ds-error">Failed to load the list.</p>
{/await}

<style>
  .page-container {
    padding: 2rem;
    max-width: 1600px;
    margin: 0 auto;
  }

  /* ===== Master / detail layout ===== */
  .master-detail-layout {
    display: flex;
    align-items: flex-start;
    gap: 1.5rem;
  }

  .filter-panel {
    flex: 0 0 320px;
    width: 320px;
    position: sticky;
    top: 1.5rem;
  }

  .detail-panel {
    flex: 1 1 auto;
    min-width: 0;
  }

  @media (max-width: 900px) {
    .master-detail-layout {
      flex-direction: column;
    }
    .filter-panel {
      width: 100%;
      position: static;
    }
  }

  /* ===== Filter panel ===== */
  .list-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    margin: 0.25rem 0 1rem;
  }

  .user-list-select {
    width: 100%;
    max-height: 420px;
    border: 1px solid var(--ds-border-3);
    border-radius: var(--ds-radius-sm);
    font-size: 0.85rem;
    font-family: inherit;
    color: var(--ds-text);
    background: var(--ds-surface);
    padding: 0.25rem;
    box-sizing: border-box;
  }

  .user-list-select:focus {
    outline: none;
    border-color: var(--ds-accent);
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
  }

  .user-list-select option {
    padding: 0.5rem 0.6rem;
    border-radius: var(--ds-radius-sm);
  }

  .user-list-select option:checked {
    background: var(--ds-accent-soft);
    color: var(--ds-accent);
  }

  /* ===== Detail panel ===== */
  .detail-panel h2 {
    font-size: 1rem;
    font-weight: 700;
    color: var(--ds-text);
    margin: 1.5rem 0 1rem;
    padding-bottom: 0.6rem;
    border-bottom: 1px solid var(--ds-border-2);
  }

  .detail-panel h2:first-child {
    margin-top: 0;
  }

  .action-row {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 1rem;
  }

  .free-plan-note {
    color: var(--ds-text-muted);
    font-size: 0.9rem;
    margin: 0 0 1rem;
  }

  .avatar {
    max-width: 200px;
    border-radius: var(--ds-radius-sm);
  }

  .ds-table-wrap {
    overflow-x: auto;
    border: 1px solid var(--ds-border);
    border-radius: var(--ds-radius-md);
    margin-bottom: 0.5rem;
  }

  .ds-loading.inline,
  .ds-error {
    padding: 1rem;
    text-align: left;
  }

  .ds-loading.inline {
    display: flex;
    align-items: center;
    gap: 0.6rem;
  }

  .ds-loading.inline .ds-spinner {
    width: 18px;
    height: 18px;
    margin: 0;
  }

  .ds-loading.inline p {
    margin: 0;
  }
</style>
